







































import {Component, Prop} from 'vue-property-decorator';
import Form from '@/components/form-base';
import { mixins } from 'vue-class-component';
import { DialogForm, FormOverlay } from '@/components/bwaff';
import config from '@/config';

@Component({
  components: {
    FormOverlay,
    DialogForm,
  }
})
export default class ShareReportPickerDialog extends mixins(Form) {
  @Prop({ default: {} })
  data: any;

  get link() {
    const { id = ''} = this.data
    return `${config.sharedReportsURL}/${id}`
  }

  close() {
    this.$emit('close');
  }

  get isTreeView() {
    return this.$store.getters.reportParams.view === 'tree'
      && this.$store.getters.tableQueryForCurrentTab.treeLevels?.some((e: string) => e) ;
  }
}
